// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d5f1820d","389":"69d50713","455":"3b88cf8e","653":"06eac8be","977":"9e471b78"}[chunkId] + ".chunk.js";
};